module.exports = __webpack_public_path__ + "static/media/Beth Schwindt.415adc56.png";